const React = require('react');
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
const SettingsAdvertiserContent = require('./settings-advertiser-content.jsx');
const {Button} = require('ui-library');

const SettingsAdvertiser = createClass({

  propTypes: {
    account: PropTypes.object
  },

  onSave() {
    this.refs.advertiserContent.onSave();
  },

  render() {
    const {account} = this.props;

    return (
      <div className='vf-settings-advertiser vf-wrapper'>

        <div className='flex'>
          <h3 className='flex-1'>Tu marca</h3>
        </div>

        <div className='row padding-1x'>
          <div className='flex flex-in-small flex-align-top'>
            <div className='flex-2 column order-2-in-small'>
              <SettingsAdvertiserContent account={account} ref='advertiserContent' />
              <div className='md-4 vf-invisible'>-</div>
              <div className='padding-horizontal-1x column md-8'>
                <Button color='primary' onClick={this.onSave}>
                  Guardar
                </Button>
              </div>
            </div>
            <div className='flex-1 order-2-in-small vf-invisible'>-</div>
          </div>
        </div>
      </div>
    );
  }

});

module.exports = SettingsAdvertiser;
